import { apiService } from '@/services/api/apiService';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

interface foodMenuItem {
    kyc_document: any;
    data: any;
    foodMenuItemName: any;
    id: any | null | undefined;

}
interface foodMenuItemState {
    data: foodMenuItem[];
    foodMenuItem: foodMenuItem | null;
    loading: boolean;
    error: string | null;
}

const PORT = import.meta.env.VITE_COOK_PORT;
const URL = import.meta.env.VITE_API_COOK_URL;

export const fetchfoodMenuItem = createAsyncThunk<foodMenuItem[], void, { rejectValue: string }>(
    'foodMenuItem/fetchfoodMenuItem',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<{ data: foodMenuItem[] }>('/get_all_food_menu_item', PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);


export const createfoodMenuItem = createAsyncThunk<foodMenuItem, any, { rejectValue: string }>(
    'foodMenuItem/createfoodMenuItem',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.post<{ data: foodMenuItem }>('/create_food_menu_item', params, PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const updatefoodMenuItem = createAsyncThunk<foodMenuItem, any, { rejectValue: string }>(
    'foodMenuItem/updatefoodMenuItem',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.put<{ data: foodMenuItem }>('update_food_menu_item', params, PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const getByIdFoodMenuItem = createAsyncThunk<
    foodMenuItem,
    { id: any },
    { rejectValue: string }
>(
    'foodMenu/getByIdFoodMenu',
    async (params, { rejectWithValue }) => {
        try {
            const config = { params };

            const response = await apiService.get<any>(
                'get_by_id_food_menu_item',
                PORT,
                URL,
                config
            );

            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    })
export const createSecondaryDietType = createAsyncThunk<foodMenuItem, any, { rejectValue: string }>(
    'foodMenuItem/createSecondaryDietType',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.post<{ data: foodMenuItem }>('create_food_menu_item_secondary_diet_type', params, PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const foodMenuItemSlice = createSlice({
    name: 'foodMenuItem',
    initialState: {
        data: [],
        foodMenuItem: [],
        loading: false,
        error: null,
    } as unknown as foodMenuItemState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Diet Mapping Code
            .addCase(fetchfoodMenuItem.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchfoodMenuItem.fulfilled, (state, action: PayloadAction<foodMenuItem[]>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchfoodMenuItem.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })

            .addCase(createfoodMenuItem.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createfoodMenuItem.fulfilled, (state, action: PayloadAction<foodMenuItem>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(createfoodMenuItem.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(updatefoodMenuItem.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updatefoodMenuItem.fulfilled, (state, action: PayloadAction<foodMenuItem>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(updatefoodMenuItem.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })

            // FoodMenuItem

            .addCase(getByIdFoodMenuItem.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getByIdFoodMenuItem.fulfilled, (state, action: PayloadAction<foodMenuItem>) => {
                state.loading = false;
                state.foodMenuItem = action.payload;
            })
            .addCase(createSecondaryDietType.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createSecondaryDietType.fulfilled, (state, action: PayloadAction<foodMenuItem>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(createSecondaryDietType.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
    },
});

export default foodMenuItemSlice.reducer;